import { memo } from "react";
import styles from "./styles.module.css";

export const Question = memo(({ text, isSelected, onClick }) => {
  return (
    <div
      className={`${styles.questionBox}${
        isSelected ? ` ${styles.questionBoxSelected}` : ""
      }`}
      onClick={onClick}
    >
      <p className="chatBotFont">{text}</p>
    </div>
  );
});
